export const limiteCaracteres = {
    RELAT_ACOMP_ASSINATURA: 35,
    RELAT_ACOMP_OBS_ITEM: 250
}